import FuseSplashScreen from '@fuse/core/FuseSplashScreen';
import FuseSuspense from '@fuse/core/FuseSuspense';
import { styled } from '@mui/material/styles';
import AppContext from 'app/AppContext';
import { useSettingsSlice } from 'app/store/settingsSlice';
import { memo, useContext, useEffect } from 'react';
import { useLocation, useNavigate, useRoutes } from 'react-router-dom';
import { useNotificationListener } from 'src/app/hooks/useNotificationListener';
import useWaitForElement from 'src/app/hooks/useWaitForElement';
import useAuthUser from '../../hooks/useAuthUser';
import NotificationPanel from '../../shared-components/notificationPanel/NotificationPanel';
import NavbarWrapperLayout1 from './components/NavbarWrapperLayout';
import ToolbarLayout1 from './components/ToolbarLayout';
import { useCurrentMerchant } from 'src/app/queries/merchant.queries';

type RootProps = any;

const Root = styled('div')<RootProps>(({ config }) => ({
  ...(config.mode === 'boxed' && {
    clipPath: 'inset(0)',
    maxWidth: `${config.containerWidth}px`,
    margin: '0 auto',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  }),
  ...(config.mode === 'container' && {
    '& .container': {
      maxWidth: `${config.containerWidth}px`,
      width: '100%',
      margin: '0 auto',
    },
  }),
}));

function Layout1(props) {
  useNotificationListener();
  const config = useSettingsSlice((store: any) => store.current.layout.config);

  const appContext = useContext(AppContext);

  const { routes } = appContext;
  const location = useLocation();
  const navigate = useNavigate();
  const user = useAuthUser();

  const merchant = useCurrentMerchant({ enabled: user?.role === 'merchant' });
  // const [promptForNovo, setPromptForNovo] = useState<boolean>();
  // const [createNovo, setCreateNovo] = useState(false);

  // useEffect(() => {
  //   if (merchant.data && promptForNovo === undefined && location.pathname !== '/sign-out') {
  //     setPromptForNovo(!!merchant.data?.data.promptForCreateNovoAccount);
  //   }
  // }, [merchant]);

  useWaitForElement('#dify-chatbot-bubble-button', (element) => {
    if (user?.onboarding && user?.role === 'merchant') {
      element.style.display = 'block';
    }
  });

  const routesComponent = useRoutes(routes || []);
  useEffect(() => {
    if (location.search.startsWith('?code') && !user?.userRole) {
      navigate(window.location.pathname);
    }
  }, [location.search, navigate, user?.userRole]);

  if (location.search.startsWith('?code') && !user?.userRole) return <FuseSplashScreen />;

  return (
    <Root id="fuse-layout" config={config} className="w-full flex">
      <div className="flex flex-auto min-w-0">
        {config.navbar.display && <NavbarWrapperLayout1 />}

        <main id="fuse-main" className="flex flex-col flex-auto min-h-full min-w-0 relative z-10">
          {config.toolbar.display && (
            <ToolbarLayout1 className={config.toolbar.style === 'fixed' && 'sticky top-0'} />
          )}

          <div className="flex flex-col flex-auto min-h-0 relative z-10">
            <FuseSuspense>{routesComponent}</FuseSuspense>

            {props.children}
          </div>
        </main>
      </div>
      {/* <PromptForNovoAccountDialog
        open={promptForNovo || false}
        handleClose={() => setPromptForNovo(false)}
        handleCreate={() => setCreateNovo(true)}
      /> */}
      {/* <CreateNovoAccountDialog open={createNovo} handleClose={() => setCreateNovo(false)} /> */}
      <NotificationPanel />
    </Root>
  );
}

export default memo(Layout1);
